import { DaisyPayoutRegister } from "../models/daisypayoutregister.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getDaisyPayoutRegister = (user_id: number): Promise<DaisyPayoutRegister[]> => {
    return new Promise<DaisyPayoutRegister[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/payoutregister/daisy/${user_id}`).then((response) => {
            resolve(response.data as DaisyPayoutRegister[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};